// extracted by mini-css-extract-plugin
export var active = "_c4-7";
export var container = "_c4-0";
export var evenWidth = "_c4-4";
export var large = "_c4-5";
export var outlet = "_c4-8";
export var slide = "_c4-2";
export var small = "_c4-6";
export var tab = "_c4-3";
export var tabs = "_c4-1";